module.exports = __webpack_public_path__ + "static/media/conce_laptop.9ce483e3.png";